<template>
  <div class="w-100">
    <v-sheet
      v-if="listLoading"
      class="d-flex flex-column justify-center"
      min-height="200px"
    >
      <div class="mx-auto">
        <v-progress-circular
          :size="40"
          color="primary"
          indeterminate
        />
      </div>
    </v-sheet>

    <v-list
      v-else-if="templateProfiles.length"
      lines="two"
    >
      <v-list-item
        v-for="profile in templateProfiles"
        :key="profile.ulid"
        :to="{ name: 'job-profile-view', params: { id: profile.ulid } }"
        class="px-6"
      >
        <template #title>
          <span class="text-body-2 font-weight-medium">{{ profile.title }}</span>
        </template>
        <template #subtitle>
          <div class="d-flex justify-space-between">
            <JobProfileMeta :profile="profile" />
            <div
              v-if="profile.locked_fields_hash !== currentJobProfile.jobProfile?.locked_fields_hash"
              class="text-caption text-warning"
            >
              Outdated
            </div>
          </div>
        </template>
      </v-list-item>
    </v-list>

    <p
      v-else
      class="text-body-2 text-medium-emphasis px-6 py-3"
    >
      No profiles have been built from this template yet.
    </p>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useAppLoading } from '@/stores/app/loading';
import JobProfileMeta from '@/components/jobProfiles/editor/JobProfileMeta.vue';

const currentJobProfile = useCurrentJobProfile();
const { templateProfiles } = storeToRefs(currentJobProfile);
const { listLoading } = storeToRefs(useAppLoading());

onMounted(() => {
  currentJobProfile.loadProfilesByTemplate();
});
</script>
